import { ReactNode } from 'react'
import { Helmet } from 'react-helmet-async'

import { getQueryParamsFromHash, parsePermittedQueryParams } from '@domain-group/javascript-utils'

import { Box, Button, Columns } from '@domain-group/suit-theme'

import ImpersonateEntityButton from '@components/ImpersonateEntityButton'
import PageHeader from '@components/PageHeader'

import useCurrentUser from '@hooks/useCurrentUser'
import useSystemManagerNestedNavigation from '@hooks/useSystemManagerNestedNavigation'
import type { UseAgencyPayload } from '@hooks/useAgency'

import generateTabBarItems from '../../utils/generateTabBarItems'

interface PageLayoutProps {
  activeTabBarItemKey?: string,
  children: ReactNode,
  entityPayload: UseAgencyPayload,
}

const PageLayout = (props: PageLayoutProps) => {
  const { activeTabBarItemKey, children, entityPayload } = props

  const {
    agency,
    callbacks: { loginAsAgency },
    urls: { agenciesIndexUrl },
  } = entityPayload

  const { isBrandUser } = useCurrentUser()

  const { redirect } = parsePermittedQueryParams(getQueryParamsFromHash(), ['redirect'])

  const { shouldUseNestedNavigation } = useSystemManagerNestedNavigation()

  return (
    <>
      <Helmet>
        <title>Edit Agency | Realhub</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <>
            <ImpersonateEntityButton
              // @ts-expect-error TS2322
              callbacks={{ loginAsEntity: loginAsAgency }}
              // @ts-expect-error TS2322
              entity={agency}
              marginRight="medium"
            />

            <Button
              // @ts-expect-error TS2322
              as="a"
              buttonStyle="secondaryUtility"
              href={redirect || agenciesIndexUrl}
              size="medium"
              width="auto"
            >
              Back
            </Button>
          </>
        )}
        activeTabBarItemKey={activeTabBarItemKey}
        nestedNavigation={shouldUseNestedNavigation}
        // @ts-expect-error TS2322
        tabBarItems={generateTabBarItems({ agency, isBrandUser })}
        title="Edit Agency"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          {children}
        </Columns>
      </Box>
    </>
  )
}

export default PageLayout
